<template>
  <FormModal
    :visible="showModalCreate != 0"
    title="Status da assinatura"
    :hide-footer="true"
    width="800px"
    @update:visible="closeModal"
  >
    <template #header>
      <div class="flex items-center gap-3">
        <svg class="w-10 h-10 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        <h2 class="text-xl font-semibold text-gray-900 dark:text-gray-100">Status da assinatura</h2>
      </div>
    </template>

    <div class="space-y-4">

      <!-- Loading spinner -->
      <div v-if="listaAssinaturas == null || listaAssinaturas.length == 0" class="flex justify-center items-center py-8">
        <div class="spinner"></div>
      </div>

      <!-- Tabela de assinaturas -->
      <div v-if="listaAssinaturas != null && listaAssinaturas.length > 0" class="space-y-4">
        <!-- Desktop table -->
        <div class="hidden md:block border border-gray-200 dark:border-slate-700 rounded-lg overflow-hidden">
          <table class="w-full">
            <thead class="bg-gray-50 dark:bg-slate-800">
              <tr>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider w-1/2">
                  Nome e E-mail
                </th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider w-1/3">
                  Status
                </th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider w-1/6">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody class="bg-white dark:bg-slate-900 divide-y divide-gray-200 dark:divide-slate-700">
              <tr
                v-for="(documentoObj, index) in listaAssinaturas"
                :key="index"
                class="hover:bg-gray-50 dark:hover:bg-slate-800 transition-colors"
              >
                <td
                  class="px-4 py-3 text-sm"
                  :title="documentoObj.NomeRepresentante + ' - E-mail: ' + documentoObj.EmailRepresentante"
                >
                  <div class="font-medium text-gray-900 dark:text-gray-100">
                    {{ formatText(documentoObj.NomeRepresentante) }}
                  </div>
                  <div class="text-gray-500 dark:text-gray-400 text-xs">
                    {{ formatText(documentoObj.EmailRepresentante) }}
                  </div>
                </td>
                <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                    :class="documentoObj.Status == 'Assinado' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200'"
                  >
                    {{ documentoObj.Status }}
                  </span>
                </td>
                <td class="px-4 py-3 text-sm">
                  <button
                    v-if="documentoObj.Status == 'Não assinado'"
                    @click="reenviarEmail(documentoObj.Guid)"
                    class="px-3 py-1.5 text-xs font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors"
                  >
                    Reenviar e-mail
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Mobile cards -->
        <div class="md:hidden space-y-3">
          <template
            v-for="(documentoObj, index) in listaAssinaturas"
            :key="index"
          >
            <div
              v-if="documentoObj.NomeRepresentante"
              class="border border-gray-200 dark:border-slate-700 rounded-lg p-4 space-y-3 bg-white dark:bg-slate-800"
            >
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Nome</p>
              <p class="text-sm font-medium text-gray-900 dark:text-gray-100">
                {{ documentoObj.NomeRepresentante }}
              </p>
            </div>

            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">E-mail</p>
              <p class="text-sm text-gray-700 dark:text-gray-300">
                {{ documentoObj.EmailRepresentante }}
              </p>
            </div>

            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Status</p>
              <span
                class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                :class="documentoObj.Status == 'Assinado' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200'"
              >
                {{ documentoObj.Status }}
              </span>
            </div>

            <button
              v-if="documentoObj.Status == 'Não assinado'"
              @click="reenviarEmail(documentoObj.Guid)"
              class="w-full px-4 py-2 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors"
            >
              Reenviar e-mail
            </button>
          </div>
          </template>
        </div>
      </div>

      <!-- Botão de ação -->
      <div class="flex justify-center pt-4">
        <button
          @click="closeModal"
          class="px-6 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-600 transition-colors min-w-[120px]"
        >
          Voltar
        </button>
      </div>
    </div>
  </FormModal>
</template>

<script>
import { mapGetters } from "vuex";
import api from "@/api/axios";
import FormModal from "@/components/FormModal.vue";

export default {
  components: {
    FormModal,
  },
  computed: {
    ...mapGetters({
      showModalCreate: "GET_MODAL_ASSINATURA_STATUS",
      listaAssinaturas: "GET_LISTA_STATUS_ASSINATURAS",
      user: "auth/user",
    }),
  },
  data() {
    return {
      aceitoTermos: false,
      erroConfirmar: false,
      requisicaoPendente: false,
      isOpen: false,
    };
  },
  watch: {
    showModalCreate() {
      if (this.showModalCreate != 0)
        this.$store.dispatch(
          "FETCH_PJ_LISTA_STATUS_ASSINATURA",
          this.showModalCreate,
        );
    },
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    closeModal() {
      this.$store.commit("SET_MODAL_ASSINATURA_STATUS", 0);
    },
    formatText(text) {
      if (!text) return ""; // Se o texto for nulo ou indefinido
      return text.length > 50 ? text.slice(0, 50) + "..." : text; // Limite de 25 caracteres
    },
    async reenviarEmail(guid) {
      var obj = {};
      this.requisicaoPendente = true;

      await api
        .post(
          `/declaracao/assinante/email?guidDeclaracaoAssinatura=${guid}`,
          obj,
        )
        .then((retorno) => {
          if (retorno.status == 200) {
            this.$alert({
              icon: "success",
              title: "Reenviar documento",
              text: "Documento foi reenviado por e-mail para assinatura",
            }).then((result) => {
              this.requisicaoPendente = false;
              if (result.value) {
                this.$store.dispatch("FETCH_CONSULTA_LISTA_DOCUMENTOS_CLIENTE");
                // this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS", 0);
                // this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE", false);
                // this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS');
                // this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_CLIENTE');
              }
            });
          } else {
            this.requisicaoPendente = false;
            this.$alert({
              icon: "error",
              title: "Oops...",
              text: `Falha ao enviar e-mail para assinatura`,
            });
          }
        })
        .catch((error) => {
          this.requisicaoPendente = false;

          this.$alert({
            icon: "error",
            title: "Falha ao vincular assinantes ao documento",
            text: `${
              error.response.data.data[0] != null
                ? error.response.data.data[0]
                : error.response.data.descricao
            }`,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/* Estilos customizados mínimos - a maioria vem do FormModal */
</style>
